import dayjs from "dayjs";
import { ROTULO_CRITICADO_CURTO, ROTULO_RETIDO } from "../retencao-vocabulario";

export function formatDate(
  dateToFormat: string,
  formatType?: "timestamp" | "date" | "timestamp_2"
) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    const date = dayjs(dateToFormat);

    const type = !formatType ? "date" : formatType;

    return type === "date"
      ? date.format(`DD/MM/YYYY`)
      : date.format("DD/MM/YYYY - HH:mm:ss");
  } catch (error) {
    const type = !formatType ? "date" : formatType;

    return type === "date"
      ? "-"
      : type === "timestamp"
      ? "--/--/---- --:--:--"
      : "-";
  }
}

export function formatType(payload: string) {
  if (payload === "EMPLOYEE") return "Titular";

  if (payload === "DEPENDENT") return "Dependente";

  return "-";
}

export function formatMovementType(payload: string) {
  if (payload === "inclusion") return "Inclusão";

  if (payload === "exclusion") return "Exclusão";

  if (payload === "change") return "Alteração";

  if (payload === "transfer") return "Transferência";

  return "-";
}

export function formatStatus(status: string) {
  if (status === "READY")
    return {
      label: "Pronto",
      backgroundColor: "#0288D114",
      color: "#01579B",
    };

  if (status === "SKIPED")
    return {
      label: ROTULO_RETIDO,
      backgroundColor: "#BA1A1A14",
      color: "#BA1A1A",
    };

  if (status === "DELAYED")
    return {
      label: "Em espera",
      backgroundColor: "#EF6C0014",
      color: "#EF6C00",
    };

  if (status === "RETAINED")
    return {
      label: ROTULO_CRITICADO_CURTO,
      backgroundColor: "#0F0F1E14",
      color: "#0F0F1E",
    };

  if (status === "DONE")
    return {
      label: "Aprovado",
      backgroundColor: "#2E7D3214",
      color: "#2E7D32",
    };

  return {
    label: "-",
    backgroundColor: "#F5F5F5",
    color: "#616161",
  };
}

export function formatActivityStatus(status: string) {
  if (status === "IDLE")
    return {
      label: "Aguardando",
      backgroundColor: "#191C1A14",
      color: "#191C1A",
    };

  if (status === "PENDING")
    return {
      label: "Pendente",
      backgroundColor: "#EF6C0014",
      color: "#EF6C00",
    };

  if (status === "SUCCESS")
    return {
      label: "Executado",
      backgroundColor: "#2E7D3214",
      color: "#2E7D32",
    };

  if (status === "FAILED")
    return {
      label: "Falhou",
      backgroundColor: "#ff7d7d3b",
      color: "#a30000",
    };

  return {
    label: "Aguardando",
    backgroundColor: "#F5F5F5",
    color: "#616161",
  };
}

type LinhaCriticada = { taxPayerId: string | number; dagRunId: string; movementType: string };

const soDigitos = (cpf: string | number) => String(cpf).replace(/\D/g, "");

// CPF com uma linha criticada: filtra por geracao e tipo. Com mais de uma (par de transferencia),
// so por geracao, e o backend atualiza todas as criticadas do CPF naquela geracao.
export function particaoDosCriticados(criticados: LinhaCriticada[]) {
  const porCpf = new Map<string, LinhaCriticada[]>();
  criticados.forEach(l => porCpf.set(soDigitos(l.taxPayerId), [...(porCpf.get(soDigitos(l.taxPayerId)) ?? []), l]));
  return Object.fromEntries(
    Array.from(porCpf, ([cpf, linhas]) => [
      cpf,
      linhas.length === 1 ? { dagRunId: linhas[0].dagRunId, movementType: linhas[0].movementType } : { dagRunId: linhas[0].dagRunId },
    ]),
  ) as Record<string, { dagRunId: string; movementType?: string }>;
}

// Uma entrada por linha criticada de cada pessoa salva com linha na massa.
export function entradasDeRetificacao(criticados: LinhaCriticada[], pessoasComLinha: { taxPayerId: string }[]) {
  const cpfs = new Set(pessoasComLinha.map(p => p.taxPayerId));
  return criticados
    .filter(l => cpfs.has(soDigitos(l.taxPayerId)))
    .map(l => ({
      dagRunId: l.dagRunId,
      taxPayerId: soDigitos(l.taxPayerId),
      movementType: l.movementType,
      status: "DONE",
      retentionReason: null,
      retentionNotes: null,
    }));
}
